import styled from 'styled-components';
import Link from 'next/link';

export const ImageLink = styled(Link)`
  position: relative;
  display: flex;
  z-index: 9;
  width: 100%;
  height: 100%;
`;

export const ShowMore = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  padding: 14.0625vw 13.75vw;
  font-size: 3.75vw;
  color: #fff;
  text-decoration: none;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  text-align: center;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.53);
  transition: opacity 0.7s;
  box-sizing: border-box;

  @media only screen and (min-width: 480px) {
    padding: 45px 44px;
    font-size: 12px;
  }
`;
